import { render, staticRenderFns } from "./MypageInventoryPage.vue?vue&type=template&id=044b3d02&scoped=true&"
import script from "./MypageInventoryPage.vue?vue&type=script&lang=js&"
export * from "./MypageInventoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044b3d02",
  null
  
)

export default component.exports